import Dragger from "antd/es/upload/Dragger";
import { useTranslation } from "react-i18next";
import { BiCloudUpload } from "react-icons/bi";

export default function UploaderWithDrag({ fileList, setFileList }) {
  const { t } = useTranslation();
  const handleDragger = (info) => {
    setFileList(info.fileList);
  };

  return (
    <div>
      <Dragger
        name='files'
        onChange={handleDragger}
        multiple={true}
        fileList={fileList}
        beforeUpload={() => false}
      >
        <div className='ant-upload-drag-icon flex justify-center my-2'>
          <BiCloudUpload size={30} />
        </div>
        <p className='ant-upload-text'>
          {t("common.clickOrDrag")}
        </p>
      </Dragger>
    </div>
  );
}
